import script from "./ThemeBudget.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThemeBudget.vue?vue&type=script&setup=true&lang=ts"

import "./ThemeBudget.vue?vue&type=style&index=0&id=e0b0719c&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0b0719c"]])

export default __exports__